export default "__VITE_ASSET__B8Jb1yor__"